'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _getNumeral = require('../../../helpers/getNumeral');

var _getNumeral2 = _interopRequireDefault(_getNumeral);

var _Numeral = require('./Numeral');

var _Numeral2 = _interopRequireDefault(_Numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormattedNumberComponent = function (_NumeralFieldComponen) {
  (0, _inherits3.default)(FormattedNumberComponent, _NumeralFieldComponen);

  function FormattedNumberComponent() {
    (0, _classCallCheck3.default)(this, FormattedNumberComponent);
    return (0, _possibleConstructorReturn3.default)(this, (FormattedNumberComponent.__proto__ || Object.getPrototypeOf(FormattedNumberComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(FormattedNumberComponent, [{
    key: 'unformatValue',
    value: function unformatValue(label) {
      return label === '' ? undefined : (0, _getNumeral2.default)()._.stringToNumber(label);
    }
  }, {
    key: 'formatValue',
    value: function formatValue(real) {
      var delimiter = (0, _getNumeral2.default)().localeData().delimiters.decimal;

      if (typeof real === 'number') {
        real = String(real).replace('.', delimiter);
      } else if (typeof real !== 'string') {
        real = String(real);
      }

      var parts = real.split(delimiter);

      var text = (0, _getNumeral2.default)()(parts[0]) ? (0, _getNumeral2.default)()(parts[0]).format('0,0.[000000000000000000000]') : '';
      if (parts[1] || real.includes(delimiter)) {
        var decimalText = parts[1] ? parts[1].replace(/\D/g, '') : '';
        return text + delimiter + decimalText;
      } else {
        return text;
      }
    }
  }]);
  return FormattedNumberComponent;
}(_Numeral2.default);

exports.default = FormattedNumberComponent;